import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import * as yup from "yup";

import Button from "@/components/UI/Button";
import { CustomForm } from "@/component-library/CustomForm";
import { dobValidationSchemaFactory } from "@/utils/yupSchemaUtils";
import FormikInput from "@/components/UI/FormikInput";
import FormikInputFormat from "@/components/UI/formikMobileInput";
import { patientRequests } from "@/api/(requests)/patient";
import { sharedRequests } from "@/api/(requests)/shared";
import { showSuccessfulSubmission } from "@/redux/actions/auth";
import { STATES } from "@/constants/states";

const GetNotified = (props) => {
  const [carriers, setCarriers] = useState([]);

  const getNotifiedSchema = [
    {
      elementConfig: {
        label: "Child’s Insurance Carrier",
        options: carriers,
        placeholder: "Select Child’s Insurance Carrier",
      },
      elementType: "select",
      name: "insurance_carrier",
    },
    {
      elementConfig: {
        label: "State",
        options: STATES,
        placeholder: "Select State",
      },
      elementType: "select",
      name: "state",
    },
  ];

  useEffect(() => {
    (async () => {
      // TODO: Consider migrating to useInsuranceList hook
      // See MemberProfileMedical.js for reference implementation
      patientRequests
        .fetch_insurance_list({ context: { showLoader: false } })
        .then((cleanResponse) => {
          // TODO: Standardize to { label, value } format (currently using { display, value })
          // See PatientProfileInsuranceInfo.js for reference implementation
          let carriersOptions = cleanResponse.carriers.map((carriers) => {
            return { display: carriers, value: carriers };
          });

          setCarriers(carriersOptions);
        });
    })();
  }, []);

  const submitHandler = async (formData) => {
    const data = {
      content: {
        dob: moment(formData.dob, "MMDDYYYY").format("MM/DD/YYYY"),
        email: formData.email,
        insurance_carrier: formData.insurance_carrier,
        state: formData.state,
      },
      event_type: "CHILD_PROGRAM_EXPANSION",
    };

    await sharedRequests.create_event_notification({ data });
    props.showSuccessfulSubmission();
    window.localStorage.removeItem("redirectAfterAuth");
    props.history.push("/app/home");
  };

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="container px-0">
            <div className="get-notified-input">
              <FormikInput
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Your Email Address",
                    placeholder: "Enter Your Email Address",
                    type: "email",
                  },
                  elementType: "input",
                  name: "email",
                }}
                key="email"
              />
            </div>
            <div className="get-notified-input">
              <FormikInputFormat
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Child's Date of Birth",
                    placeholder: "MM/DD/YYYY",
                    type: "text",
                  },
                  elementType: "input",
                  name: "dob",
                }}
                key="dob"
                onChange={async (val) => {
                  await formikProps.setFieldValue("dob", val.value);
                  formikProps.setFieldTouched("dob");
                }}
                value={formikProps && formikProps.values["dob"]}
              />
            </div>
            {getNotifiedSchema.map((formEl) => {
              return (
                <div className="get-notified-input" key={formEl.name}>
                  <FormikInput
                    errors={formikProps.errors}
                    formEl={formEl}
                    key={formEl.name}
                    touched={formikProps.touched}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex pb-5 tw:justify-center">
          <Button className="Btn Btn--sec self-signup-btn" type="submit">
            Submit
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <div className="get-notified">
      <div className="fs-20 get-notified-title text-center tw:font-bold">
        Thank you for your interest in aptihealth’s Teens + Kids Care Program. Please provide your
        contact information below to be notified when your child becomes eligible.
      </div>
      <CustomForm
        onSubmit={submitHandler}
        render={renderForm}
        validationSchema={getNotifiedValidation}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps, { showSuccessfulSubmission })(GetNotified);

const getNotifiedValidation = yup.object().shape({
  dob: dobValidationSchemaFactory("MMDDYYYY").required("Date of birth is required"),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  insurance_carrier: yup.string().required("Insurance Carrier is required"),
  state: yup.string().required("State is required"),
});
